import { useState } from 'react'
import { useTrackMutation } from '@mote/api'
import { ArrowUpRightIcon } from '@mote/assets/icons'
import { TRACK_EVENT_NAMES } from '@mote/helpers/constants'
import { Button } from '@mote/ui'
import type { ShareDialogProps } from './ShareDialog'
import { ShareDialog } from './ShareDialog'

export interface ShareDialogWithTriggerProps
  extends Omit<ShareDialogProps, 'isOpen' | 'onClose'> {
  buttonSize?: 'sm' | 'md' | 'lg'
}

export function ShareDialogWithTrigger(props: ShareDialogWithTriggerProps) {
  const [isDialogShown, setDialogShown] = useState(false)
  const trackMutation = useTrackMutation()

  function handleShowPanel() {
    setDialogShown(true)
    //@ts-expect-error
    trackMutation.mutate({
      variables: {
        event: TRACK_EVENT_NAMES.sharePanel.clicked,
        location: 'web'
      }
    })
  }

  return (
    <>
      <Button
        //@ts-expect-error
        icon={<ArrowUpRightIcon />}
        text='Share'
        onClick={handleShowPanel}
        size={props.buttonSize || 'sm'}
        data-testid='share-mote-button'
      />
      <ShareDialog
        playbackLocation={props.playbackLocation}
        moteId={props.moteId}
        isDownloadButtonHidden={props.isDownloadButtonHidden}
        isClassroomButtonHidden={props.isClassroomButtonHidden}
        onClose={() => setDialogShown(false)}
        isOpen={isDialogShown}
      />
    </>
  )
}
